import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-8 gap-8 h-full box-shadow-profile mx-4 border" }

import { computed, markRaw, onMounted } from "vue";
import { useRouter } from "vue-router";

import { useUserStore } from "@/stores/user";

import UserCard from "@/components/molecules/UserCard.vue";
import TabTemplate from "@/components/templates/TabTemplate.vue";
import UserSharesTab from "@/views/admin/tabs/UserSharesTab.vue";
import UserIdentificationTab from "@/views/admin/tabs/UserIdentificationTab.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetailView',
  setup(__props) {

const shareholderStore = useUserStore();
const router = useRouter();

const shareholderId = computed(() =>
  Number(router.currentRoute.value.params.id)
);

onMounted(() => {
  shareholderStore.query(shareholderId.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(UserCard, { class: "col-span-8 border-b-[#9BB441] border-b-[20px] px-5" }),
    _createVNode(TabTemplate, {
      class: "col-span-8 px-8",
      tabs: [
        { name: 'Identificación', view: markRaw(UserIdentificationTab) },
        { name: 'Accionistas', view: markRaw(UserSharesTab) },
      ]
    }, null, 8, ["tabs"])
  ]))
}
}

})